import { createSelector } from 'reselect';

export const selectUser = (state: any) => state.user;

export const selectCurrent = createSelector([selectUser], (user) => user.value);


